import gql from 'graphql-tag';
import React, { useCallback, useMemo } from 'react';
import { useNavigation } from '@react-navigation/native';

import { POS_TYPE, PREDEFINED_USER_ROLES } from '../../../common/constants';
import { useUserContext } from '../../../common/utils/context';
import { getFullMachineName } from '../../../common/utils/machine';
import { EmptyState, Screen } from '../../design/components';
import PointOfSaleList from './PointOfSaleList';

export const GET_POINTS_OF_SALE_FOR_PLANOGRAM_MOBILE = gql`
	query(
		$page: Int,
		$perPage: Int,
		$sortBy: String!,
		$sortDirection: Int!,
		$filter: MachinePageFilter
	) {
		getMachines(
			page: $page,
			perPage: $perPage,
			sortBy: $sortBy,
			sortDirection: $sortDirection,
			filter: $filter
		) {
			items {
				id
				assetId
				type
				isInactive
				place {
					id
					name
				}
				location {
					id
					name
					client {
						id
						name
					}
				}
			}
			count
		}
	}
`;

const PointOfSaleListView = () => {
	const navigation = useNavigation();
	const { user, isAVC } = useUserContext();
	const canAccessPointOfSaleList = useMemo(() => user && (user.isSuperAdmin || (isAVC && user.role.name === PREDEFINED_USER_ROLES.ADMIN)), [user, isAVC]);

	const onPressPointOfSale = useCallback((pointOfSale) => {
		navigation.navigate('MachineDetailTabView', {
			machineId: pointOfSale.id,
			machineName: getFullMachineName(pointOfSale, pointOfSale.place, pointOfSale.location),
			locationId: pointOfSale.location?.id,
			isMarket: pointOfSale.type === POS_TYPE.MARKET,
		});
	}, [navigation]);

	if (!canAccessPointOfSaleList) {
		return (
			<Screen heading="Points of sale">
				<EmptyState icon="lock" title="No access" message="You do not have access to points of sale." />
			</Screen>
		);
	}

	return (
		<Screen heading="Points of sale" scroll={false}>
			<PointOfSaleList
				query={GET_POINTS_OF_SALE_FOR_PLANOGRAM_MOBILE}
				initialSortBy="assetId"
				initialSortDirection={1}
				initialPerPage={25}
				initialFilter={{}}
				listId="mobile_point_of_sale_planogram_list"
				customProps={{
					onPressItem: onPressPointOfSale,
				}}
			/>
		</Screen>
	);
};

export default PointOfSaleListView;
